/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 6/11/2021
 */

import {
	ref,
	listAll,
	uploadBytesResumable,
	getDownloadURL,
	getMetadata
} from "firebase/storage"

export default class StorageRef{

	ref
	parent


	constructor(storage, path) {
		if(storage.constructor.name === "Reference"){
			this.ref = storage
		} else {
			this.ref = ref(storage, path);
		}
	}

	get fullPath() {
		return this.ref.fullPath
	}
	get root() {
		return this.ref.root
	}
	get bucket() {
		return this.ref.bucket
	}
	get name() {
		return this.ref.name
	}
	get storage() {
		return this.ref.storage
	}
	// get parent() {
	// 	return this.ref.parent
	// }


	child(path){
		let ref = new StorageRef(this.ref.storage, this.ref.fullPath + '/' + path)
		ref.parent = this
		return ref
	}

	async listAll(){
		let res = await listAll(this.ref)
		res.items = res.items.map(ref => new StorageRef(ref))
		return res
	}

	put(bytes, metadata){
		return uploadBytesResumable(this.ref, bytes, metadata)
	}

	async getDownloadURL(){
		return getDownloadURL(this.ref)
	}

	async getMetadata(){
		return getMetadata(this.ref)
	}


}
